export const support = {
  inject: [
    "TheSp",
  ],
}
